import React  from 'react';
import './App.css';

import { useNavigate } from "react-router-dom";

class TaskNewComment extends React.Component {

	constructor(props) {

		super(props);
		
		this.state = {
			commentText: "",
		};

		this.onCommentTextChanged = this.onCommentTextChanged.bind(this);
		this.serverInsertTaskComment = this.serverInsertTaskComment.bind(this);
		this.onClickSaveButton = this.onClickSaveButton.bind(this);
		this.onClickCancelButton = this.onClickCancelButton.bind(this);
	}
	
	onCommentTextChanged(value) {
		this.setState({commentText: value});
	}

	async serverInsertTaskComment(taskID, userID, userName, commentText) {

		var baseURLAPI = this.props.baseURLAPI;
		var url = baseURLAPI + "/inserttaskcommentrecord?taskid=" + taskID;
		url = url + "&userid=" + userID;
		url = url + "&username=" + encodeURIComponent(userName);
		url = url + "&commenttext=" + encodeURIComponent(commentText);
		
		const res = await fetch(url);
		await res.text();

		this.props.showToast("New comment saved");
		this.props.setSelectedTab("info");
	}
		
	async serverCheckIfTaskExistsYN(taskName) {

		var baseURLAPI = this.props.baseURLAPI;
		var url = baseURLAPI + "/gettaskdatafromtaskName?taskName=" + taskName;
		
		const res = await fetch(url);
		const textResponse = await res.text();

		if (textResponse === "[]") {
			return false;
		} else {
			return true;
		}
	}
	
	async onClickSaveButton() {
		
		var commentText = this.state.commentText;
		if (commentText === "") {
			this.props.showToast("Comment text cannot be empty");
			return;
		}
		
		var userID = this.props.userID;
		var userName = this.props.firstName + " " + this.props.lastName;
		userName = userName.trim();
		if (userName === "") {
			userName = this.props.email;
		}	

		this.serverInsertTaskComment(this.props.taskID, userID, userName, commentText);
	}
	
	onClickCancelButton() {
		this.props.setSelectedTab("info");
	}
	
	render() {		
		return (
			<div className="ViewContainer1">
				<div style={{height: "30px"}}></div>
				<div className="ViewTopTitle">New comment</div>
				<div className="ViewTopText">Enter comment text, then press save</div>

				<div style={{height: "30px"}}></div>
				<div className="ViewBlockContainer">
					<div style={{height: "15px"}}></div>
					<div className="ViewBlockTitle">Comment</div>
					<div style={{height: "20px"}}></div>
					<div className="ViewContainer2">
						<fieldset className="ViewItemFieldset">
							<legend className="ViewItemLegend">Task name</legend> 
							<input
								className="ViewItemInput" 
								id="taskName" 
								type="text" 
								defaultValue={this.props.taskName}
								disabled={true}
							/>
						</fieldset>
						<div style={{height: "10px"}}></div>
						<fieldset className="ViewItemFieldset">
							<legend className="ViewItemLegend">Comment</legend> 
							<textarea
								className="ViewItemInput" 
								id="commentText" 
								rows={15}
								autoFocus={true}
								onChange={(event) => this.onCommentTextChanged(event.target.value)}
							/>
						</fieldset>
					</div>
					<div style={{height: "60px"}}></div>
					<div className="ViewContainerButtons">
						<div style={{width: "200px"}}></div>
						<button className="ViewCancelButton" onClick={this.onClickCancelButton}>Cancel</button>
						<div style={{width: "20px"}}></div>
						<button className="ViewSaveButton" onClick={this.onClickSaveButton}>Save</button>
					</div>
					<div style={{height: "50px"}}></div>
				</div>

				<div style={{height: "100px"}}></div>
			</div>
		);
	}
}

export default function TaskNewCommentFunction(props) {
	const navigate = useNavigate();
	return <TaskNewComment {...props} navigate={navigate} />;
}

